import dateFns from 'date-fns'

import AppPage from '../../mixins/app-page'
import AppBtn from '../app-btn'
import AppYoutube from '../app-youtube'
import AppSeasonComingSoon from '../app-season-coming-soon'


// URL list
import URL from '../../../config.url'


export default
{
    name: 'page-match-details',

    components:
    {
        AppBtn,
        AppYoutube,
        AppSeasonComingSoon
    },

    mixins:
    [
        AppPage
    ],

    data()
    {
        return {
            matchSlug: null,
            currentLang: null,
            currentRound: null,
            roundsSameLang: [],
            langOpen: false
        }
    },

    watch:
    {
        params: '_init'
    },

    created()
    {
        this._init()
    },

    mounted()
    {
        if (this.contentPage.code === 404)
        {
            this.eventHub.$emit('bg-change', '/static/bg/bg-coming-soon.jpg')
        }
        else
        {
            if (this.hasVideo())
            {
                this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
            }
            else
            {
                const gameSlug = this.getVideoGameFromID(this.contentPage.upcoming.videoGameID).slug
                this.eventHub.$emit('bg-change', '/static/bg/bg-' + gameSlug + '.jpg')
            }
        }
    },

    methods:
    {
        goto(roundSlug = this.currentRound.slug, langId = null)
        {
            const url = this.getMatchUrl(roundSlug, langId)
            this.$root.changePage(url)
        },

        hasVideo()
        {
            return this.currentRound && this.currentRound.youtubeId
        },

        getMatchUrl(roundSlug = this.currentRound.slug, langId = null)
        {
            const slug = this.matchSlug
            const lang = langId ? this._getLangDataById(langId) : this.currentLang
            const langSlug = lang ? lang.slug : ''

            if (langSlug !== '')
            {
                return this.$root.getPageURLFromID('esMatchDetailsFilterLang')
                        .replace(':slug', slug)
                        .replace(':filter', roundSlug)
                        .replace(':lang', langSlug)
            }

            return this.$root.getPageURLFromID('esMatchDetailsFilterLang')
                    .replace(':slug', slug)
                    .replace(':filter', roundSlug)
        },

        getFlag(slug)
        {
            return '/static/team/icon-flag-' + slug.toLowerCase() + '.png'
        },

        openModalRegister()
        {
            this.$root.openModalPlay('match')
        },

        _init()
        {
            if(this.contentPage.rounds)
            {
                const rounds = JSON.parse(JSON.stringify(this.contentPage.rounds))

                const langSlug = this.params.langFilter
                const roundSlug = this.params.filter
                this.matchSlug = this.params.slug

                // GET LANGUAGE
                if (langSlug)
                {
                    this.currentLang = this._getLangDataBySlug(langSlug)
                }
                else if (rounds.find(data => data.langId > -1))
                {
                    const round = rounds.find(data => data.langId > -1)
                    this.currentLang = round ? this._getLangDataById(round.langId) : null
                }

                // GET ROUND
                if (roundSlug)
                {
                    if (langSlug && this.currentLang)
                    {
                        this.currentRound = this._getRound(roundSlug, this.currentLang.id)
                    }
                    else
                    {
                        this.currentRound = rounds.find(data => data.slug === roundSlug) || rounds[0]
                    }
                }
                else
                {
                    this.currentRound = rounds[0]
                }

                // GET OTHER ROUNDS
                if (this.currentLang)
                {
                    this.roundsSameLang = rounds.filter(data => data.langId === this.currentLang.id)
                }
                else
                {
                    this.roundsSameLang = rounds
                }
            }
        },

        _getLangDataBySlug(slug = null)
        {
            const data = this.contentPage.languages.find(lang => lang.slug === slug)
            return data || this.contentPage.languages[0]
        },

        _getRound(roundSlug, langId)
        {
            const rounds = JSON.parse(JSON.stringify(this.contentPage.rounds))

            return rounds.find(data => data.slug === roundSlug && data.langId == langId)
                        || rounds.find(data => data.langId == langId)
                        || rounds.find(data => data.slug === roundSlug)
                        || rounds[0]
        },

        _getLangDataById(langId = this.currentLang.id)
        {
            console.log(this.contentPage.languages)
            const data = this.contentPage.languages.find(lang => lang.id === langId)
            return data || this.contentPage.languages[0]
        },


        // ------------------------------
        //      VIDEO NOT AVAILABLE

        getTeamFromID(id)
        {
            return this.contentGlobal.teams.find(team => parseInt(team.id, 10) === id)
        },

        getVideoGameFromID(id)
        {
            return this.contentGlobal.videoGames.find(game => parseInt(game.id, 10) === id)
        },

        getUpcommingDate()
        {
            const currentDate = Math.round(Date.now() / 1000)
            const releaseDate = this.contentPage.upcoming.dateStart

            if (currentDate < releaseDate)
            {
                return dateFns.format(releaseDate * 1000, 'DD[.]MM[.]YYYY [—] h[:]mm[<sup>]a[</sup>]') + ' - ' + this.contentPage.upcoming.dateInfo
            }

            return false
        },

        getUpcomminCounter()
        {
            const currentDate = Math.round(Date.now() / 1000)
            const releaseDate = this.contentPage.upcoming.dateStart

            if (currentDate >= releaseDate)
            {
                return this.contentPage.upcoming.upcomming
            }
            else if (currentDate < releaseDate)
            {
                if (dateFns.isSameDay(releaseDate * 1000, currentDate * 1000))
                {
                    return this.contentPage.upcoming.upcomming
                    // this.contentGlobal.taxonomies.matches.beginsAt + ' ' + dateFns.format(releaseDate * 1000, 'h[:]mm[<sup>]a[</sup>]')
                }
                else
                {
                    const daysDiff = dateFns.differenceInCalendarDays(releaseDate * 1000, currentDate * 1000)

                    let diff
                    if (daysDiff > 1)
                    {
                        diff = daysDiff + ' ' + this.contentGlobal.taxonomies.words.days
                    }
                    else if (daysDiff > 0)
                    {
                        diff = daysDiff + ' ' + this.contentGlobal.taxonomies.words.day
                    }

                    return this.contentGlobal.taxonomies.matches.beginsIn + ' ' + diff
                }
            }

            return this.contentGlobal.taxonomies.matches.finished
        },


        // ------------------------------
        //      LANG MENU

        _onLangListClick()
        {
            this.langOpen = true
        },

        _onLangListOver()
        {
            if (!this.$root.isTouch)
            {
                this.langOpen = true
            }
        },

        _onLangListLeave()
        {
            this.langOpen = false
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-match-details/script.js